import React from 'react';
import { graphql } from 'gatsby';

import Seo from 'components/container/Seo';
import SectionHero from 'components/container/SectionHero';
import PageBuilder from 'components/container/PageBuilder';

export default function TemplateHome({ data, pageContext }) {
  const url = pageContext?.url;
  const heroBackground = data?.heroBackground;
  const heroHeadlineImage = data?.heroHeadlineImage;
  const imageTextBackground = data?.imageTextBackground;
  const seoTitle = data?.seoTitle;
  const seoDescription = data?.seoDescription;
  const seoImage = data?.seoImage;
  const socialsBackground = data?.socialsBackground;

  const { pageBuilderNeo } = data?.craft?.entry;

  // console.log(pageContext);

  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDescription}
        image={seoImage?.[0]?.socialMediaUrl}
        url={url}
      />
      <SectionHero
        backgroundImage={heroBackground}
        heroHeadlineImage={heroHeadlineImage}
        heroTitleImageAlt="Endlich was erfrischendes im www. Ist doch wahr."
      />
      <PageBuilder
        components={pageBuilderNeo}
        backgroundImage={imageTextBackground}
        backgroundImages={[imageTextBackground, socialsBackground]}
      />
    </>
  );
}

export const query = graphql`
  query QueryHomeNL($id: [Int]!, $siteId: Int) {
    craft {
      # entry for PageBuilder ImageText
      entry(id: $id, siteId: $siteId) {
        ... on Craft_HomeNl {
          title
          seoTitle
          seoDescription
          seoImage {
            socialMediaUrl: url(transform: transformSocialMedia)
          }
          pageBuilderNeo {
            ...PageBuilderQuery
          }
        }
      }
    }

    heroBackground: file(
      relativePath: { eq: "hero/warsteiner-hero-background.jpg" }
    ) {
      ...imageDefault
    }

    heroHeadlineImage: file(
      relativePath: { eq: "hero/serious-about-beer-hashtag.png" }
    ) {
      ...imageDefault
    }

    socialsBackground: file(relativePath: { eq: "bg-2.jpg" }) {
      ...imageDefault
    }

    socialsInstagramBackground: file(
      relativePath: { eq: "warsteiner-socials-instagram-background.jpg" }
    ) {
      ...imageDefault
    }

    socialsYoutubeBackground: file(
      relativePath: { eq: "warsteiner-socials-youtube-background.png" }
    ) {
      ...imageDefault
    }

    imageTextBackground: file(
      relativePath: { eq: "warsteiner-stage-content-bg.jpg" }
    ) {
      ...imageDefault
    }

    undercoverBossImage: file(
      relativePath: { eq: "Kampagnen/undercover-boss.jpg" }
    ) {
      ...imageDefault
    }
  }
`;
